<div class="modal-header">
  <h4 class="modal-title">{{ isEdit ? "Edit Channel" : "Add Channel" }}</h4>
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" ngbAutofocus>
  <myp-inline-loader [loading]="loading" height="200px" spinnerName="addEditChannelLoader"></myp-inline-loader>

  @if (!loading) {
    <div class="row">
      <div class="form-group col-md-6">
        <label class="control-label" for="channel-title">Title (English)</label>
        <input type="text" name="title_en" id="channel-title" [(ngModel)]="titles.en" (ngModelChange)="recomputeMissing()" class="form-control" />
      </div>
      <div class="form-group col-md-6">
        <label class="control-label" for="channel-string-id">String ID (kebab-case, cannot change once created)</label>
        <input type="text" name="string_id" id="channel-string-id" [disabled]="isEdit" [(ngModel)]="channel.string_id" class="form-control" placeholder="feature-requests" />
      </div>

      <div class="form-group col-12">
        <label class="control-label" for="channel-description">Description (English, optional)</label>
        <textarea name="description_en" id="channel-description" [(ngModel)]="descriptions.en" (ngModelChange)="recomputeMissing()" class="form-control" rows="2"></textarea>
      </div>

      <div class="form-group col-12">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <button type="button" class="btn btn-sm btn-blank p-0 m-r-10" (click)="showAllLanguages = !showAllLanguages">
              <fa-icon [icon]="showAllLanguages ? 'chevron-down' : 'chevron-right'"></fa-icon>
              {{ showAllLanguages ? "Hide" : "Show" }} translations
            </button>
            @if (missingTranslations) {
              <span class="pill red sm">
                <fa-icon icon="exclamation-triangle"></fa-icon>
                Missing translations
              </span>
            } @else if (titles.en) {
              <span class="pill green sm">
                <fa-icon icon="check"></fa-icon>
                Fully translated
              </span>
            }
          </div>
          <button type="button" class="btn btn-sm btn-secondary" [disabled]="translating || !titles.en" (click)="autoTranslate()">
            {{ translating ? "Translating…" : "Auto-translate" }}
          </button>
        </div>
        <small class="text-muted">Missing translations fall back to English at read time. Auto-translate fires one request per language in parallel.</small>
      </div>

      @if (showAllLanguages) {
        <div class="col-12">
          <div class="border-radius10 p-15 trans-bg">
            @for (lang of otherLanguages; track lang.code) {
              <div class="row m-b-10">
                <div class="col-md-2 d-flex align-items-center">
                  <span
                    class="pill sm"
                    [class.gray]="langStatus[lang.code] === 'idle' || langStatus[lang.code] === 'translating'"
                    [class.green]="langStatus[lang.code] === 'done'"
                    [class.red]="langStatus[lang.code] === 'error'"
                  >
                    @if (langStatus[lang.code] === "translating") {
                      <fa-icon icon="spinner" animation="spin"></fa-icon>
                    } @else if (langStatus[lang.code] === "done") {
                      <fa-icon icon="check"></fa-icon>
                    } @else if (langStatus[lang.code] === "error") {
                      <fa-icon icon="exclamation-triangle"></fa-icon>
                    }
                    {{ lang.code }}
                  </span>
                </div>
                <div class="col-md-5">
                  <label class="control-label t-12" [for]="'channel-title-' + lang.code">Title</label>
                  <input type="text" [id]="'channel-title-' + lang.code" [name]="'title_' + lang.code" [(ngModel)]="titles[lang.code]" class="form-control form-control-sm" />
                </div>
                <div class="col-md-5">
                  <label class="control-label t-12" [for]="'channel-desc-' + lang.code">Description</label>
                  <input
                    type="text"
                    [id]="'channel-desc-' + lang.code"
                    [name]="'desc_' + lang.code"
                    [(ngModel)]="descriptions[lang.code]"
                    class="form-control form-control-sm"
                    [disabled]="!descriptions.en"
                  />
                </div>
              </div>
            }
          </div>
        </div>
      }

      <div class="form-group col-md-4">
        <label class="control-label" for="channel-ordering">Order</label>
        <input type="number" name="ordering" id="channel-ordering" [(ngModel)]="channel.ordering" class="form-control" />
      </div>
      <div class="form-group col-md-4 d-flex align-items-end">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="channel-is-public" name="is_public" [(ngModel)]="channel.is_public" />
          <label class="form-check-label" for="channel-is-public">Public</label>
        </div>
      </div>
      <div class="form-group col-md-4 d-flex align-items-end">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="channel-is-alphabetical" name="is_alphabetical" [(ngModel)]="channel.is_alphabetical" />
          <label class="form-check-label" for="channel-is-alphabetical">Alphabetical (sort into A–Z list)</label>
        </div>
      </div>

      <div class="form-group col-12">
        <myp-switch
          [active]="restrictPosting"
          label="Restrict post authors"
          sublabel="Only members of the selected groups can start posts here. Anyone can still reply, and community moderators and admins can always post."
          [labelToRight]="true"
          (toggle)="toggleRestrictPosting()"
        ></myp-switch>
        @if (restrictPosting) {
          <div class="posting-groups m-t-10">
            @if (groupsLoading) {
              <span class="text-muted t-14">
                <fa-icon icon="spinner" [animation]="'spin'" class="m-r-5"></fa-icon>
                Loading groups…
              </span>
            } @else if (postingGroups.length) {
              <div class="d-flex flex-wrap align-items-center">
                @for (name of postingGroups; track name) {
                  <span class="pill gray sm m-r-5 m-b-5">
                    {{ name }}
                    <button type="button" class="fa-button m-l-5" (click)="removePostingGroup(name)" [attr.aria-label]="'Remove ' + name">
                      <fa-icon icon="times" aria-hidden="true"></fa-icon>
                    </button>
                  </span>
                }
                <button type="button" class="btn btn-sm btn-secondary m-b-5" (click)="openPostingGroupPicker()">Edit Groups</button>
              </div>
            } @else {
              <button type="button" class="btn btn-sm btn-secondary" (click)="openPostingGroupPicker()">Select Groups</button>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-link" (click)="activeModal.dismiss('Cancel click')">Cancel</button>
  <button type="button" class="btn btn-primary" [disabled]="loading" (click)="submit()">
    {{ isEdit ? "Save" : "Create" }}
  </button>
</div>
